import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HomeComponent } from './home.component';
import { ModalModule } from 'src/app/common/components/modal/modal.module';
import { DashboardModule } from '../dashboard/dashboard.module';
import { TableModule } from 'src/app/common/utilities/table/table.module';
import { ButtonOutlineModule } from 'src/app/common/utilities/buttons/button-outline/button-outline/button-outline.module';
import { FilterModule } from 'src/app/common/components/filter/filter.module';
import { NgxJsonViewerModule } from 'ngx-json-viewer';
import { ButtonFillModule } from 'src/app/common/utilities/buttons/button-fill/button-fill/button-fill.module';
import { RequestTableModule } from 'src/app/common/components/request-table/request-table.module';

@NgModule({
  declarations: [
    HomeComponent
  ],
  imports: [
    CommonModule,
    ModalModule,
    DashboardModule,
    TableModule,
    ButtonOutlineModule,
    FilterModule,
    NgxJsonViewerModule,
    ButtonFillModule,
    RequestTableModule
  ]
})
export class HomeModule { }
